import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
export var InstallStatus = function InstallStatus() {
    _classCallCheck(this, InstallStatus);

    this.status = false;
};
export var ThirdPartyAuthData = function ThirdPartyAuthData() {
    _classCallCheck(this, ThirdPartyAuthData);
};
export var QQMusicLogin = function QQMusicLogin() {
    _classCallCheck(this, QQMusicLogin);

    this.openId = '';
    this.token = '';
    this.timeStamp = '';
};
export var LoginStatus = function LoginStatus() {
    _classCallCheck(this, LoginStatus);

    this.isLogin = false;
    this.isLogining = false;
};
export var UserInfo = function UserInfo() {
    _classCallCheck(this, UserInfo);

    this.userId = '';
    // tslint:disable-next-line:variable-name
    this.user_center_access_token = '';
    // tslint:disable-next-line:variable-name
    this.uhome_access_token = '';
    this.offUserId = '';
    this.phoneNumber = '';
    this.realName = '';
    this.avatar = '';
    this.nickname = '';
    this.email = '';
    this.username = '';
};
export var UserInfoNew = function UserInfoNew() {
    _classCallCheck(this, UserInfoNew);

    this.nickname = '';
    this.avatarUrl = '';
    this.birthday = '';
    this.email = '';
    this.extraPhone = '';
    this.gender = '';
    this.givenName = '';
};
export var AuthData = function AuthData() {
    _classCallCheck(this, AuthData);
};
export var OauthData = function OauthData() {
    _classCallCheck(this, OauthData);
};